import React from 'react';

/**
 * Компонент для галереи с главным изображением справа.
 * @param {Object} props              данные, пришедшие от родителя
 * @param {Element} props.main_image  главное изображение
 * @param {Array} props.gallery       массив с изображениями
 * 
 * @class
 */
export const GalleryRight = (props) => (
  <div className="pupils-work__gallery-right">
    <div className="pupils-work__gallery__small-container">
      {
        props.gallery.map((item, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html : item}} />
        ))
      }
    </div>
    <div className="pupils-work__gallery__big-container">
      <div dangerouslySetInnerHTML={{ __html : props.main_image}} />
    </div>
  </div>
)

export default GalleryRight;